module.exports = __webpack_public_path__ + "static/media/iconYoutube.4491bf70.svg";